import React, { createContext, lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Spinner from "./components/spinner";
import About from "./pages/about/about";
import BoardOfDirectors from "./pages/about/board-of-directors";
import BusinessModel from "./pages/about/business-model";
import CodeOfConductsAndPolicies from "./pages/about/code-of-conducts-and-policies";
import DiversityAndInclusion from "./pages/about/diversity-and-inclusion";
import ExecutiveAndLeadershipTeam from "./pages/about/executive-and-leadership-team";
import OurProjects from "./pages/about/our-projects";
import OurValueAndApproach from "./pages/about/our-value-and-approach";
import Overview from "./pages/about/overview";
import Strategy from "./pages/about/strategy";
import AfroAcademy from "./pages/afro-academy";
import AfroMagazines from "./pages/afro-magazines";
import Agriculture from "./pages/agriculture";
import AllProject from "./pages/all-project";
import AppStore from "./pages/app-store";
import Career from "./pages/career";
import Clients from "./pages/clients";
import Contact from "./pages/contact";
import CountryProject from "./pages/country-project";
// import ContactUs from "./pages/contact-us";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AfroInterns from "./pages/afro-interns";
import BuildYourCareer from "./pages/build-your-carrer";
import DigitalMarketing from "./pages/digital-marketing";
import Investors from "./pages/investors";
import Magazine from "./pages/magazine";
import Maps from "./pages/maps";
import MediaCenter from "./pages/media-center";
import NotFound from "./pages/not-found";
import Partners from "./pages/partners";
import PrivacyAndPolicy from "./pages/privacy-and-policy";
import ProjectDetails from "./pages/project-details";
import Projects from "./pages/projects";
import Services from "./pages/services";
import Sitemap from "./pages/sitemap";
import SmartHomes from "./pages/smart-homes";
import SocialSite from "./pages/social-site";
import SoftwareApps from "./pages/software-apps";
import SolarAlternativeEnergy from "./pages/solar-alternative-energy";
import Solutions from "./pages/solutions";
import Suppliers from "./pages/suppliers";
import Sustainability from "./pages/sustainability";
import TermsAndCondition from "./pages/terms-and-condition";
import WhatWeDoService from "./pages/what-we-do-service";
import WhereWeWork from "./pages/whereWeWork";
import WorkPortfolio from "./pages/work-portfolio";
const HomePage = lazy(() => import("./pages/homePage"));

export const HeaderAndFooterContext = createContext();

const App = () => {
  return (
    <div className="overflow-hidden">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Routes>
        <Route
          path="/"
          index
          element={
            <Suspense fallback={<Spinner />}>
              <HomePage />
            </Suspense>
          }
        />

        <Route path="/about" element={<About />}>
          <Route path="/about/overview" element={<Overview />} />
          <Route path="/about/strategy" element={<Strategy />} />
          <Route
            path="/about/presentation-&-reports"
            element={<DiversityAndInclusion />}
          />
          <Route path="/about/business-model" element={<BusinessModel />} />
          <Route path="/about/leadership-team" element={<BoardOfDirectors />} />
          <Route
            path="/about/management-team"
            element={<ExecutiveAndLeadershipTeam />}
          />
          <Route path="/about/our-projects" element={<OurProjects />} />
          <Route
            path="/about/our-value-and-approach"
            element={<OurValueAndApproach />}
          />
          <Route
            path="/about/governance-&-policies"
            element={<CodeOfConductsAndPolicies />}
          />
        </Route>
        <Route path="/where-we-work" element={<WhereWeWork />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/sustainability" element={<Sustainability />} />
        {/* Footer Helpfull Links */}
        <Route path="/media-center" element={<MediaCenter />} />
        <Route path="/afro-academy" element={<AfroAcademy />} />
        <Route path="/suppliers" element={<Suppliers />} />
        <Route path="/career" element={<Career />} />
        <Route path="/investors" element={<Investors />} />
        <Route path="/all-magazine" element={<AfroMagazines />} />
        <Route path="/magazine/:id" element={<Magazine />} />
        <Route path="/service/:id" element={<WhatWeDoService />} />
        <Route path="/work-portfolio/:id" element={<WorkPortfolio />} />
        <Route path="/contact-us" element={<Contact />} />

        {/* Footer Industries Links */}
        <Route
          path="/industry/solar-alternative-energy"
          element={<SolarAlternativeEnergy />}
        />
        <Route path="/industry/agriculture" element={<Agriculture />} />
        <Route path="/industry/smart-homes" element={<SmartHomes />} />
        <Route path="/industry/software-apps" element={<SoftwareApps />} />
        <Route
          path="/industry/digital-marketing"
          element={<DigitalMarketing />}
        />
        <Route path="/terms-and-condition" element={<TermsAndCondition />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/clients/project/:id" element={<Projects />} />
        <Route path="/countries/project/:id" element={<CountryProject />} />
        <Route path="/services" element={<Services />} />
        <Route
          path="/clients/project-details/:id"
          element={<ProjectDetails />}
        />
        <Route path="/clients" element={<Clients />} />
        <Route path="/all-projects" element={<AllProject />} />
        <Route path="/maps" element={<Maps />} />
        <Route path="/privacy-and-policy" element={<PrivacyAndPolicy />} />
        <Route path="/app-store" element={<AppStore />} />
        <Route path="/build-your-career" element={<BuildYourCareer />} />
        <Route path="/afro-interns" element={<AfroInterns />} />
        <Route path="/afrosocial247" element={<SocialSite />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default App;
